import APIUtils from '@spothero/utils/api';
import ObjectUtils from '@spothero/utils/object';

const CreditAPI = {
    /* eslint-disable camelcase */
    checkPromoCode({
        email,
        price,
        promoCode: promo_code,
        ruleGroupId: rule_group_id,
        ruleType: rule_type,
        spotId: parking_spot_id,
        currencyType: currency_type,
        starts,
        ends,
    }) {
        return APIUtils.post('promocodes/check/', {
            email,
            parking_spot_id,
            price,
            promo_code,
            rule_group_id,
            rule_type,
            currency_type,
            starts,
            ends,
        })
            .then(({data: {data}}) => ObjectUtils.camelizeKeys(data))
            .then(data => {
                return {
                    ...data,
                    creditAmount: (data.creditAmount || 0) / 100,
                    discountAmount: (data.discountAmount || 0) / 100,
                    percentageOff: data.percentageOff || 0,
                    percentageOffDiscountMax:
                        (data.percentageOffDiscountMax || 0) / 100,
                };
            });
    },
    /* eslint-enable camelcase */

    update(requestData) {
        const {
            userId,
            amountChanged,
            reason,
            reservationId,
            currencyType,
        } = requestData;

        return APIUtils.patch(
            `users/${userId}/credit/`,
            {
                /* eslint-disable camelcase */
                currency_type: currencyType.toLowerCase(),
                credit_delta: parseFloat(amountChanged),
                reason,
                referenced_rental_id: reservationId,
                notify_user: false,
                /* eslint-enable camelcase */
            },
            {
                headers: {
                    'Content-Type': 'application/json',
                },
            }
        ).then(
            ({
                data: {
                    data: {spothero_credit: credit},
                },
            }) => credit
        );
    },

    getUpdateReasons() {
        return APIUtils.get('credit-reason/');
    },
};

export default CreditAPI;
